import React from "react";
import { useState, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

export function FadeinscrollComponent(props) {
    const [isVisible, setVisible] = useState(false);
    const domRef = useRef();
    useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      let domRefCurrent = domRef.current;
      // observer.observe(domRef.current);
      // let test = document.querySelector('.animate');
      observer.observe(domRef.current);
      return () => observer.unobserve(domRefCurrent);
    }, []);
    return (
    <CSSTransition
      in={isVisible}
      classNames={props.aniStyle}
      timeout={1000}
      nodeRef={domRef}
    >
      <div ref={domRef} className="animate">
        {props.children}
      </div>
    </CSSTransition>
    );
  }